<div class="profile-container">
    <div class="">
        <div class="profile-content">    
            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off" >
                                <input type="text" (keyup.enter)="getAllAssetDepreciationMethodByWildSearch()" [ngModelOptions]="{standalone: true}" placeholder="search" [(ngModel)]="searchFilter">
                            </form>
                            <i class="bi bi-search" (click)="getAllAssetDepreciationMethodByWildSearch()"></i>
                        </div>
                        <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                        <div class="filter-icon">
                            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                        </div>
                    </div>
                </div>

                <table class="table table-striped">
                    <thead>
                        <tr>
                        <th style="width: 40%;">{{ 'asset-deprciation-method.methodName' | translate }}</th>
                        <th style="width: 40%;">{{ 'asset-deprciation-method.methodDescription' | translate }}</th>
                        <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" id="{{list.id}}" [ngClass]="{ 'delete-highlight': list.assetDepreciationMethodId == recordId }" *ngFor="let list of assetDepreciationDataList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }  ;let i = index">

                        <p style="width: 40%;">{{list.methodName || '--'}}</p>
                        <p style="width: 40%;">{{list.methodDescription || '--'}}</p>
                        <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                            <i *ngIf="actionControls.isModify" title="Edit" class="bi bi-pencil-square" (click)="getAssetDepreciationMethodById(list.assetDepreciationMethodId)" data-toggle="modal" data-target="#editModal" ></i>
                            <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3" (click)="deleteIdSelect(list.id,list)" data-toggle="modal" data-target="#deleteModal"></i>
                        </p>
                    </div>
                </div>


                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>

                <div class="loader"  *ngIf="!isLoading && assetDepreciationDataList.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>

                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                    [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                    </p-paginator>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalDelete" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteAssetDepreciationMethod()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ 'asset-deprciation-method.headings.add' | translate }}
            <span data-dismiss="modal">
                <i class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body">
            <div [formGroup]="addForm">
                <div class="form-group">
                    <label>{{ 'asset-deprciation-method.methodName' | translate }} <span class="required">*</span></label>
                    <input formControlName="methodName" type="text" class="form-control">
                </div>
                <div class="form-group">
                    <label>{{ 'asset-deprciation-method.methodDescription' | translate }}</label>
                    <textarea formControlName="methodDescription" class="form-control" name="" id=""></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="closeModalAdd" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>

                <button type="button" (click)="addAssetDepreciationMethod()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
            </div>
        </div>
      </div>
    </div>
</div>

<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'asset-deprciation-method.headings.edit' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="updateForm">
                    <div class="form-group">
                        <label>{{ 'asset-deprciation-method.methodName' | translate }} <span class="required">*</span></label>
                        <input formControlName="methodName" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>{{ 'asset-deprciation-method.methodDescription' | translate }}</label>
                        <textarea formControlName="methodDescription" class="form-control" name="" id=""></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalUpdate" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="updateAssetDepreciationMethod()" class="btn btn-primary">{{ 'generic.update' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>